(function () {
  var section = document.querySelector('[data-svf-section]');
  if (!section) return;

  var dataScript = document.querySelector('[data-svf-data]');
  var posts = [];
  try {
    posts = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error('Shoppable feed: could not parse post data', e);
    return;
  }

  var modal = document.querySelector('[data-svf-modal]');
  var modalVideo = modal.querySelector('[data-svf-modal-video]');
  var modalProducts = modal.querySelector('[data-svf-modal-products]');
  var prevBtn = modal.querySelector('[data-svf-prev]');
  var nextBtn = modal.querySelector('[data-svf-next]');

  var currentIndex = 0;

  function renderPost(index) {
    var post = posts[index];
    if (!post) return;
    currentIndex = index;

    modalVideo.pause();
    modalVideo.src = post.videoUrl || '';
    modalVideo.load();
    modalVideo.muted = true;
    modalVideo.play().catch(function () {
      /* autoplay may be blocked; user can press play */
    });

    modalProducts.innerHTML = '';
    (post.products || []).forEach(function (p) {
      var li = document.createElement('li');
      li.className = 'svf-product';
      li.innerHTML =
        '<img src="' + (p.image || '') + '" alt="" loading="lazy">' +
        '<div class="svf-product__info">' +
          '<p class="svf-product__title">' + escapeHtml(p.title) + '</p>' +
          '<p class="svf-product__price">' + escapeHtml(p.price) + '</p>' +
        '</div>' +
        '<a class="svf-product__view" href="' + p.url + '">View</a>';
      modalProducts.appendChild(li);
    });

    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === posts.length - 1;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function openModal(index) {
    renderPost(index);
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    document.body.style.overflow = '';
  }

  section.querySelectorAll('[data-svf-open]').forEach(function (card) {
    card.addEventListener('click', function () {
      var idx = parseInt(card.getAttribute('data-svf-index'), 10);
      openModal(idx);
    });
  });

  modal.querySelectorAll('[data-svf-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  prevBtn.addEventListener('click', function () {
    if (currentIndex > 0) renderPost(currentIndex - 1);
  });

  nextBtn.addEventListener('click', function () {
    if (currentIndex < posts.length - 1) renderPost(currentIndex + 1);
  });

  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft' && currentIndex > 0) renderPost(currentIndex - 1);
    if (e.key === 'ArrowRight' && currentIndex < posts.length - 1) renderPost(currentIndex + 1);
  });
})();